var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowHeadCircleDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_544",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24419",
    "data-name": "Group 24419",
    transform: "translate(-1153 -608)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1153, 608)",
    filter: "url(#Ellipse_544)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_544-2",
    "data-name": "Ellipse 544",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-ios-left",
    transform: "translate(1179.919 647.041) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_-Icon-\\u0421olor",
    "data-name": "\\uD83C\\uDFA8-Icon-\\u0421olor",
    d: "M16.394,25.163a1.438,1.438,0,0,1-1.123-.537L8.318,15.984a1.441,1.441,0,0,1,.016-1.825l7.2-8.641a1.44,1.44,0,1,1,2.212,1.843L11.3,15.1l6.215,7.722a1.441,1.441,0,0,1-1.122,2.343",
    transform: "translate(-8 -5.001)",
    fill: "#0068f5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHeadCircleDown);
export default __webpack_public_path__ + "static/media/arrow-head-circle-down.195f95e9699b5eba42d0f0d7857ce6d6.svg";
export { ForwardRef as ReactComponent };